import React from "react";
import { AnimatedLogo } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Image from "next/image";

interface AnimatedLogoProps {
  blok?: AnimatedLogo & SbBlokData;
  bg?: string;
}

const AnimatedLogoComponent: React.FC<AnimatedLogoProps> = ({ blok, bg = "bg-dark" }) => {
  if (!blok) return null;

  const { title, content, logos } = blok;

  // Split logos into two groups for different rows
  const halfLength = logos ? Math.ceil(logos.length / 2) : 0;
  const firstRowLogos = logos?.slice(0, halfLength);
  const secondRowLogos = logos?.slice(halfLength);

  const renderLogoRow = (logosGroup: typeof logos, isReverse = false) => {
    if (!logosGroup) return null;

    // Duplicate logos for continuous scrolling effect
    const duplicatedLogos = [...logosGroup, ...logosGroup];

    return (
      <div className={`mx-auto align-items-center horizontal-scrolling ${isReverse ? 'horizontal-scrolling-reverse' : ''}`}>
        {[1, 2].map((groupIndex) => (
          <div key={groupIndex} className="horizontal-scrolling-inner horizontal-scrolling-badges mb-4">
            {duplicatedLogos.map((logo, index) => (
              <div key={`${logo.id}-${groupIndex}-${index}`} className="card shadow-lg p-3 rounded-pill me-3">
                {logo.filename && (
                  <Image
                    src={logo.filename}
                    alt={logo.alt || logo.name}
                    width={80}
                    height={80}
                    className="js-lazy-load"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    loading="lazy"
                    quality={75}
                  />
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <section
      className={`${bg} py-4 py-lg-5 py-xl-6 component-animated-logos`}
      {...storyblokEditable(blok)}
    >
      <div className="container overflow-hidden">
        <div className="row align-items-center g-5">
          <div className="col col-lg-12">
            {renderLogoRow(firstRowLogos)}
            {renderLogoRow(secondRowLogos, true)}
          </div>
          <div className="col col-lg-12">
            {title && <h2>{title}</h2>}
            {content && <p className="lead">{content}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnimatedLogoComponent;